import { jsxs as i, Fragment as y, jsx as o } from "react/jsx-runtime";
import S from "../ExternalLink/ExternalLink.js";
import n from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import k from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import w from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import I from "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { trimText as b } from "@propify-tenant-client/common";
import { useState as E } from "react";
import F from "react-linkify";
const M = k({
  seeMoreButton: {
    background: "#E4F1FF",
    borderRadius: 3.5,
    fontWeight: 500,
    fontSize: 15,
    color: "#0C57A5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6.5,
    width: 115,
    whiteSpace: "nowrap",
    cursor: "pointer",
    textAlign: "center",
    paddingLeft: 6
  },
  expandedIcon: {
    transform: "rotate(180deg)"
  }
}), jo = ({
  children: m,
  isDefaultExpanded: s = !1,
  minLength: p = 80,
  idealLength: c = 100,
  maxLength: a = 200,
  typographyProps: d = {},
  useLinkify: l = !0
}) => {
  const [r, f] = E(s), e = M(), x = b(m, p, c, a), t = r ? m : x[0] || "";
  return /* @__PURE__ */ i(y, { children: [
    /* @__PURE__ */ o(n, { mb: 2, children: /* @__PURE__ */ o(w, { ...d, children: l ? /* @__PURE__ */ o(
      F,
      {
        componentDecorator: (h, u, g) => /* @__PURE__ */ o(S, { href: h, children: u }, g),
        children: t
      }
    ) : t }) }),
    t.length > p && /* @__PURE__ */ i(n, { py: 0.5, className: e.seeMoreButton, onClick: () => f(!r), children: [
      /* @__PURE__ */ i("span", { children: [
        "See ",
        r ? "Less" : "More"
      ] }),
      /* @__PURE__ */ o(I, { className: r ? e.expandedIcon : void 0 })
    ] })
  ] });
};
export {
  jo as SeeMore
};
//# sourceMappingURL=SeeMore.js.map
